import EuroIcon from '@mui/icons-material/Euro';
import React from 'react';

export const ORDER_RETRACTABLE = {
  contentTab: 'RETRACTABLE',
  label: 'Commandes rétractables',
  filters: [
    {
      label: 'Status de commandes',
      path: 'status',
      staticName: 'orderStatus',
      checkedItems: ['BEING_DELIVERED_TO_CUSTOMER', 'TAV_DELIVERY_SUCCEED'],
      defaultList: ['BEING_DELIVERED_TO_CUSTOMER', 'TAV_DELIVERY_SUCCEED'],
    },
    {
      label: 'Type de contact',
      checkedItems: ['Professionnel', 'Marketplace', 'Particulier'],
      path: 'contact.store.contactType',
      staticName: 'contactType',
      defaultList: ['Professionnel', 'Marketplace', 'Particulier'],
    },
    {
      label: 'Types de commandes',
      checkedItems: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
      path: 'type',
      staticName: 'orderTypes',
      defaultList: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
    },
    {
      label: 'Marques',
      checkedItems: [],
      path: 'contact.store.brand',
      staticName: 'brand',
      defaultList: [
        'Casanoov',
        'Cazeboo',
        'Sicaan',
        'LeroyMerlin',
        'Bricoman',
        'Allegro',
        'ePrice',
        'Kaufland',
        'Worten',
        'Bricodepot',
        'Leclerc',
        'Home24',
        'But',
        'ManoMano',
        'Brico',
        'Praxis',
        'Castorama',
        'Hornbach',
        'Amazon',
      ],
    },
    {
      label: 'Magasins',
      checkedItems: [],
      path: 'contact.store',
      staticName: 'stores',
      defaultList: [],
    },
  ],
  // query will be always applied and cannot be modified by filters
  query: {
    isRetractable: true,
  },
  //Need at least 1 option, by default the first option is choosen
  sortOptions: [
    {
      label: 'Date ↓',
      value: {
        createdAt: -1,
      },
    },
    {
      label: 'Date ↑',
      value: {
        createdAt: 1,
      },
    },
  ],
  // by default Dates are in order.dates[props]
  table: [
    {
      label: 'Référence',
      code: 'REF',
      props: 'reference',
    },
    {
      label: 'Date de la commande',
      code: 'DATE',
      props: 'createdAt',
    },
    {
      label: 'Client',
      code: 'CONTACT',
      props: 'contact',
    },
    {
      label: 'Paiement',
      code: 'PRICE',
      props: 'price',
    },
    {
      label: 'Statut de la commande',
      code: 'STATUS',
      props: 'status',
    },
    {
      label: 'Actions',
      code: 'ACTION',
      props: {
        icon: <EuroIcon fontSize="small" />,
        textContent: 'Calculer les frais',
        isDisabled: false,
        isDisplayed: true,
      },
    },
  ],
};
